import { render, staticRenderFns } from "./initComponent.vue?vue&type=template&id=332452c1&scoped=true"
import script from "./initComponent.vue?vue&type=script&lang=js"
export * from "./initComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332452c1",
  null
  
)

export default component.exports